import { writable } from 'svelte/store'
import { config } from '../config.js'
import { get, post, del } from '../services/http.js'
import { auth } from '../services/auth.js'

const initialState = {}
function createUserRented() {
  const load = async () => {
    let user = await auth.getAuthenticatedUser()

    if (user) {
      await get(`${config.apiUrl}/orders/rentals`).then((data) => {
        if (data.error) {
          set(initialState)
        } else {
          data.errorMsg = null
          set(data)
        }
      })
    } else {
      set(initialState)
    }
  }
  const { subscribe, set, update } = writable(load() || initialState)

  return {
    subscribe,
  }
}

export let userRented = createUserRented()
